import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_search_reset extends PureComponent {
  render() {
    return (
      <div className="row" id="component_search_reset">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Search Reset</h2>
              <p>
                The search reset component resets all search filters, and all
                search filter components back to their default values.
              </p>
              <InterfaceCompatibility
                dashboard={false}
                record={true}
                report={false}
                search={true}
              />
              <InterfaceProperties
                type={"search_reset_search"}
                name={"search reset"}
                searchGroup={true}
                padding={true}
                hide={true}
                order={true}
                tabIndex={true}
                displayName={false}
                sourceUrl={false}
                sourceSave={false}
              />
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Search Reset Example</h2>
            </section>
            <section>
              <h3>Example 1: Search Reset</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"search_reset_search"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"Reset Search"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"search_group"</span>:{" "}
                  <span className="jsonY">"record_results_1"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"show_search_button"</span>:{" "}
                  <span className="jsonP">true</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_search_reset;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_search_reset.js